
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx",
      function () {
        return require("private-next-pages/mobiworkx/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx"])
      });
    }
  